class PgGallery extends HTMLElement {
    constructor() {
        super();
        this.images = [];
        this.currentIndex = 0;
    }

    connectedCallback() {
        this.lightbox = this.querySelector('.pg-gallery__lightbox');
        this.lightboxImage = this.querySelector('.pg-gallery__lightbox-image');
        this.closeButton = this.querySelector('.pg-gallery__lightbox-close');
        this.prevButton = this.querySelector('.pg-gallery__lightbox-prev');
        this.nextButton = this.querySelector('.pg-gallery__lightbox-next');
        this.currentCounter = this.querySelector('.pg-gallery__current');
        this.totalCounter = this.querySelector('.pg-gallery__total');
        this.items = this.querySelectorAll('.pg-gallery__item');

        this.collectImages();
        this.setupEventListeners();
        this.altText = this.querySelector('.pg-gallery__lightbox-alt-text');
    }

    collectImages() {
        this.items.forEach((item) => {
            const img = item.querySelector('.pg-gallery__image');
            if (img) {
                this.images.push({
                    src: img.src.replace(/width=\d+/, 'width=2000'),
                    alt: img.alt,
                });
            }
        });
        this.totalCounter.textContent = this.images.length;
    }

    setupEventListeners() {
        this.items.forEach((item, index) => {
            item.addEventListener('click', () => this.openLightbox(index));
        });

        this.closeButton.addEventListener('click', () => this.closeLightbox());
        this.prevButton.addEventListener('click', () => this.showPrevious());
        this.nextButton.addEventListener('click', () => this.showNext());

        this.lightbox.addEventListener('click', (e) => {
            if (e.target === this.lightbox) this.closeLightbox();
        });

        document.addEventListener('keydown', (e) => {
            if (!this.lightbox.classList.contains('active')) return;
            if (e.key === 'Escape') this.closeLightbox();
            if (e.key === 'ArrowLeft') this.showPrevious();
            if (e.key === 'ArrowRight') this.showNext();
        });
    }

    openLightbox(index) {
        this.currentIndex = index;
        this.updateLightboxImage();
        this.lightbox.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    closeLightbox() {
        this.lightbox.classList.remove('active');
        document.body.style.overflow = '';
    }

    showPrevious() {
        this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
        this.updateLightboxImage();
    }

    showNext() {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;
        this.updateLightboxImage();
    }

    updateLightboxImage() {
        const image = this.images[this.currentIndex];
        this.lightboxImage.src = image.src;
        this.lightboxImage.alt = image.alt;
        this.altText.textContent = image.alt;
        this.currentCounter.textContent = this.currentIndex + 1;
    }
}

customElements.define('pg-gallery', PgGallery);

